export const ADD_MODEL_WITH_VERSION_REQUEST = "ADD_MODEL_WITH_VERSION_REQUEST";
export const ADD_MODEL_WITH_VERSION_SUCCESS = "ADD_MODEL_WITH_VERSION_SUCCESS";
export const ADD_MODEL_WITH_VERSION_FAILURE = "ADD_MODEL_WITH_VERSION_FAILURE";
